var map = {
	"./close.svg": "864a",
	"./comment.svg": "0fae",
	"./comment_black.svg": "949c",
	"./download.svg": "039a",
	"./download_black.svg": "8900",
	"./eye-off.svg": "4ce4",
	"./eye-on.svg": "de42",
	"./go_back.svg": "c0d1",
	"./imagesLose.svg": "a39c",
	"./rocket.svg": "2cf6",
	"./undo.svg": "18d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";